import { CONSULTING_WINDOW, REDUCERS } from '../../constants.js';

const initialConsulting = {
  reducer_type : REDUCERS.REDUCER_ACTIOS_FROM_SM,
  consulting : 0
};

const consultingCounter = (state = initialConsulting, action) => {
  switch (action.type) {
    case CONSULTING_WINDOW.CONSULTING:
      return  { actionType: CONSULTING_WINDOW.CONSULTING, consulting :  state.consulting + 1 };
    case CONSULTING_WINDOW.NO_CONSULTING:
      const consult = state.consulting - 1 >= 0 ? state.consulting - 1 : 0;
      return { actionType: CONSULTING_WINDOW.NO_CONSULTING, consulting : consult };
    default:
      return state;
  }
}

export default consultingCounter;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_consulting.js